// extracted by mini-css-extract-plugin
export default {"listContainer":"QrCard_listContainer__GoknE"};